import styled from "styled-components"
import media from "src/styles/media"
import Img from "gatsby-image"

export const DepoimentosWrapper = styled.section`
    height: auto;
    width: 100%;
    margin-top: 150px;
    background-color: #100138;
    margin-bottom: 150px;

    .hero-column{
      transform: translateX(-20px);
       overflow: visible;
       z-index: 4;

      ${media.lessThan("md")`
       transform: translateX(-5px);
      `} 
    }

    ${media.lessThan("lg")`
        margin-bottom: 120px;
    `} 

    ${media.lessThan("md")`
        margin-top: 70px;
        margin-bottom: 60px;    
    `} 

    ${media.lessThan("sm")`
        margin-top: 50px;
    `} 
        
    @media screen and (min-width: 1700px){
        margin-top: 250px;
    }
`

export const CurveTop = styled(Img)`
  position: absolute;
  top: 8px;
  left: -5px;
  width: 100.1%;
  transform: translateY(-100%);
  z-index: 3;

  ${media.lessThan("md")`
        width: 102%;
        left: -1.5%;
        top: 2px;
    `}
`

export const CurveBottom = styled(Img)`
  position: absolute;
  bottom: 0;
  transform: translateY(99.5%);
  left: 0;
  width: 100%;
  z-index: 3;

  ${media.lessThan("md")`
        bottom: 2px;
    `}
`

export const DepoimentosContent = styled.div`
  height: auto;
  margin-top: -60px;

  @media screen and (min-width: 1870px) {
    margin-top: -190px;
  }
`

export const DepoimentosHeader = styled.header`
  position: relative;
  text-align: center;
  z-index: 4;

  ${media.lessThan("lg")`
        text-align: center;
    `};
`

export const DepoimentosTitle = styled.h2`
  font-size: 64px;
  font-weight: 600;
  line-height: 0.8;
  margin-bottom: 40px;
  letter-spacing: -1.5px;
  text-align: inherit;
  color: #fff;

  ${media.lessThan("lg")`
        font-size: 50px;
        `}

  ${media.lessThan("sm")`
        font-size: 40px;
        margin-bottom: 30px;
    `}
`

export const DepoimentosSubTitle = styled.h3`
  font-size: 22px;
  margin-bottom: 4px;
  opacity: 0.85;
  font-weight: 300;
  letter-spacing: 1px;
  color: #fff;

  ${media.lessThan("md")`
       text-align: center;
    `}

  ${media.lessThan("md")`
       font-size: 16px;
    `}
`

export const DepoimentosHero = styled(Img)`
  margin: 0 auto;
  margin-top: -180px;
  margin-bottom: 30px;
  width: 300px;
  animation: float 3s infinite;
  z-index: 4;

  ${media.lessThan("lg")`
       margin-top: -170px;
       width: 300px;
    `}

  ${media.lessThan("sm")`
       margin-top: -30px;
       width: 200px;
    `}
`
